export enum RealEstateFormFieldNames {
  Id = "id",
  Name = "name",
  Area = "area", 
  RoomCount = "roomCount",
  MonthlyRent = "monthlyRent",
  Charges = "charges",
  Photo = "photo",
  SurveyForm = "surveyForm",
  PropertyType = "propertyType",
  RentalType = "rentalType",
}
